import { render, staticRenderFns } from "./NuevaReferenciaDialogComponent.vue?vue&type=template&id=660974e0&scoped=true"
import script from "./NuevaReferenciaDialogComponent.vue?vue&type=script&lang=js"
export * from "./NuevaReferenciaDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./NuevaReferenciaDialogComponent.vue?vue&type=style&index=0&id=660974e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660974e0",
  null
  
)

export default component.exports